import { http } from '@/http'

const PATH = 'app/'

class HomeService {
  async getDataCard (month = null, year = null) {
    const params = {
      month: month,
      year: year
    }

    return await http.get(PATH.concat('card-data'), { params })
  }

  async getDataChart (year = null) {
    const params = {
      year: year
    }

    return await http.get(PATH.concat('data-chart'), { params })
  }

  async getPpvList (month = null, year = null) {
    const params = {
      month: month,
      year: year
    }

    return await http.get(PATH.concat('ppv-list'), { params })
  }
}

export default new HomeService()
export { PATH }
